interface PlaceholderProps {
  title: string;
}

/**
 * Shared "coming soon" placeholder for routes whose feature work lands in
 * Phase 2 (e.g. flow editor, prompt editor). Renders the localized title
 * and a Phase-2 stub note so operators see something meaningful instead
 * of a 404.
 */
export function Placeholder({ title }: PlaceholderProps): JSX.Element {
  return (
    <div>
      <h1 className="text-2xl font-bold">{title}</h1>
      <p className="mt-2 text-sm text-gray-600">準備中（Phase 2）</p>
    </div>
  );
}
